/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'done': {
    width: 9,
    height: 8,
    viewBox: '0 0 9 8',
    data: '<path pid="0" d="M3.3 4.891L1.2 2.61 0 3.913 3.3 7.5 9 1.304 7.8 0z" _fill="#91C38A" fill-rule="nonzero"/>'
  }
})
